import { Node, SelectionNode } from 'data/types'
import React, { useEffect } from 'react'

import SingleInput from './SingleInput'

type SingleSelectionProps = {
  onChange: (options: Node) => void
  options: Array<Node>
  singleSelection?: boolean
}

const SingleInputSelection = ({ onChange, options, singleSelection }: SingleSelectionProps) => {
  useEffect(() => {
    if (options.length === 0) return

    const checkedOption = options.find(
      (option) => option.type === 'SELECTION' && option.checked === true
    )

    if (!checkedOption) {
      onChange({ ...options[0], checked: true } as Node)
    }
  }, [options.length])

  return (
    <>
      {(options as Array<SelectionNode>).map((option) => (
        <SingleInput
          singleSelection={singleSelection}
          key={option.id}
          label={option.text}
          description={option.description}
          checked={option.checked ?? false}
          onChange={onChange}
          option={option}
        />
      ))}
    </>
  )
}

export default SingleInputSelection
